require('./retailLoanPickupPicker.scss');
require('./retailLoanPickupPicker.override.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
// @commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { OKLink } = require('commonsComponents/OKLink');
// @constants
const PROVINCES = require('constants/provinces');
const { getTranslatedRoad } = require('constants/typeOfRoads');
const { LOANS_INDEX_POSTAL_CODE, LOANS_GOOGLE_MAPS_URL } = require('../../../../loansConstants/index');
// @Utilities
const { toCamelCase } = require('utilities/stringHelper');

class RetailLoanPickupPicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    handleIconClick(e) {
        if (this.props.onPickClick) {
            // Prevent to fire the clic behaviour when the icon is pressed
            e.stopPropagation();
        }
    }

    handlePickupClick(immItem) {
        if (this.props.onPickClick) {
            this.props.onPickClick(immItem);
        }
    }

    buildGroupedItems(immItem) {
        return immItem
            // Add the province to each item
            .map(immPickup => {
                const code = immPickup.getIn(['pickup_place_address', 'road_postal_code']);
                return immPickup.set('province', PROVINCES[code.slice(0, LOANS_INDEX_POSTAL_CODE)]);
            })
            // Group by province
            .groupBy(immPickup => immPickup.get('province'))
            .sort((a, b) => a.getIn([0, 'province']).localeCompare(b.getIn([0, 'province'])))
            // create each accordion with toList() to transform the object in an array
            .map((immPickup, index) => this.buildAccordion(immPickup, index)).toList();
    }

    buildPickupPoint(immPoints) {
        const { onPickClick, immSelectedOffice } = this.props;
        const showBox = !!onPickClick;

        return immPoints.map((immItem, index) => {
            const immAddress = immItem.get('pickup_place_address');
            const immLocation = immItem.get('pickup_place_location');
            const typeOfRoads = toCamelCase(getTranslatedRoad(immAddress.get('road_type')) || '');
            const url = `${LOANS_GOOGLE_MAPS_URL}api=1&query=${immLocation.get('latitude')},${immLocation.get('longitude')}&` +
                `query_place_id=${immLocation.get('pickup_place_id')}`;
            const itemClass = classnames({
                'retail-loan-pickup-picker__box': showBox,
                'retail-loan-pickup-picker__box--selected': immItem.equals(immSelectedOffice),
                'retail-loan-pickup-picker__underline': !showBox,
            });

            return (
                <div key={`item-${index}`} className="col-sm-6 retail-loan-pickup-picker__item">
                    <div className={itemClass} onClick={() => this.handlePickupClick(immItem)}>
                        <div className="retail-loan-pickup-picker__name">
                            {`${immItem.get('pickup_place_name')}`}
                        </div>
                        <div className="retail-loan-pickup-picker__address">
                            {`${typeOfRoads} ${immAddress.get('road_name')} ${immAddress.get('road_number')}, `}
                            {`${immAddress.get('road_additional_info')} ${immAddress.get('road_locality')}`}
                        </div>
                        <OKLink
                            modifier="inherit-styles"
                            onClick={(e) => this.handleIconClick(e)}
                            target="_blank"
                            to={url}
                        >
                            <i className="icon-locacion-lineal retail-loan-pickup-picker__icon" />
                        </OKLink>
                    </div>
                </div>
            );
        });
    }

    buildAccordion(immItem, index) {
        const province = immItem.getIn([0, 'province']);
        const pickupPoint = this.buildPickupPoint(immItem);

        return (
            <Accordion
                key={`accordion-${index}`}
                onClick={() => this.setState({ [province]: !this.state[province] })}
                isExpanded={this.state[province]}
                customClassName="retail-loan-pickup-picker__accordion">
                <AccordionHeader
                    name="AccordionHeader"
                    iconStyle="standalone"
                    handlerToggle={() => this.setState({ [province]: !this.state[province] })}
                >
                    <div className="retail-loan-pickup-picker__accordion-header">
                        {province}
                    </div>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="retail-loan-pickup-picker__accordion-body">
                        {pickupPoint}
                    </div>
                </AccordionBody>
            </Accordion>
        )
    }

    render() {
        const { immOffice } = this.props;
        const accordions = this.buildGroupedItems(immOffice);

        return (
            <section className="retail-loan-pickup-picker">
                {accordions}
            </section>
        )
    }
}

RetailLoanPickupPicker.propTypes = {
    immOffice: PropTypes.object,
    immSelectedOffice: PropTypes.object,
    onPickClick: PropTypes.func,
};


module.exports = { RetailLoanPickupPicker };
